export default [
  {
    name: 'type',
    options: ['create', 'edit', 'delete', 'other'],
    titleTranslate: 'filters.actions.title',
    optionTranslatePrefix: 'filters.actions.options.',
    optionTranslateSuffix: '',
  },
  {
    name: 'product',
    options: ['-1', '1', '2', '3', '4', '5', '6', '7', '9', '10', '11'], //  8 voices
    titleTranslate: 'filters.products.title',
    optionTranslatePrefix: 'filters.products.options.',
    optionTranslateSuffix: '',
  },
  {
    name: 'category',
    options: [
      'followup',
      'CUSTOMIZE_CONFIG',
      'alert',
      'automatic-alert',
      'automatic-alert-customer-exception',
      'campaign',
      'cases',
      'checkin_form',
      'city',
      'collect',
      'concierge',
      'customer',
      'followup',
      'mailing',
      'online',
      'prestay_general',
      'product',
      'reports',
      'reviews',
      'roles_and_access',
      'semantic',
      'surveys',
      'user',
      'user_alerts',
      'user_permissions',
      'users',
      'whatsapp',
    ],
    titleTranslate: 'filters.resources.title',
    optionTranslatePrefix: 'logs.resources.',
    optionTranslateSuffix: '.title',
  },
  {
    name: 'user',
    options: [],
    titleTranslate: 'filters.users.title',
    optionTranslatePrefix: '',
    optionTranslateSuffix: '',
  },
];